import { App } from 'app'
import { AuthProvider } from 'modules/user/hoc/auth-provider'
import { ReduxProvider } from 'modules/user/hoc/redux-provider'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import 'styles/tailwind.css'

const element = document.getElementById('root') as HTMLElement
const root = createRoot(element)

root.render(
    <HelmetProvider>
        <AuthProvider>
            <ReduxProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ReduxProvider>
        </AuthProvider>
    </HelmetProvider>,
)
